import(/* webpackMode: "eager" */ "/home/nawar/dev/app/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nawar/dev/app/src/view/about/Client.js");
